/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankruptcyCapabilityResponse
 */
export interface BankruptcyCapabilityResponse {
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    monthlyIncome: number;
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    monthlyExpenses: number;
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    seizableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    maintenanceObligationCount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyCapabilityResponse
     */
    isAssetInventoryComplete: boolean;
}

/**
 * Check if a given object implements the BankruptcyCapabilityResponse interface.
 */
export function instanceOfBankruptcyCapabilityResponse(value: object): value is BankruptcyCapabilityResponse {
    if (!('monthlyIncome' in value) || value['monthlyIncome'] === undefined) return false;
    if (!('monthlyExpenses' in value) || value['monthlyExpenses'] === undefined) return false;
    if (!('seizableAmount' in value) || value['seizableAmount'] === undefined) return false;
    if (!('maintenanceObligationCount' in value) || value['maintenanceObligationCount'] === undefined) return false;
    if (!('isAssetInventoryComplete' in value) || value['isAssetInventoryComplete'] === undefined) return false;
    return true;
}

export function BankruptcyCapabilityResponseFromJSON(json: any): BankruptcyCapabilityResponse {
    return BankruptcyCapabilityResponseFromJSONTyped(json, false);
}

export function BankruptcyCapabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankruptcyCapabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthlyIncome': json['monthlyIncome'],
        'monthlyExpenses': json['monthlyExpenses'],
        'seizableAmount': json['seizableAmount'],
        'maintenanceObligationCount': json['maintenanceObligationCount'],
        'isAssetInventoryComplete': json['isAssetInventoryComplete'],
    };
}

export function BankruptcyCapabilityResponseToJSON(json: any): BankruptcyCapabilityResponse {
    return BankruptcyCapabilityResponseToJSONTyped(json, false);
}

export function BankruptcyCapabilityResponseToJSONTyped(value?: BankruptcyCapabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthlyIncome': value['monthlyIncome'],
        'monthlyExpenses': value['monthlyExpenses'],
        'seizableAmount': value['seizableAmount'],
        'maintenanceObligationCount': value['maintenanceObligationCount'],
        'isAssetInventoryComplete': value['isAssetInventoryComplete'],
    };
}

